import { render, staticRenderFns } from "./TestReportInfo.vue?vue&type=template&id=bc99fb10&scoped=true&"
import script from "./TestReportInfo.vue?vue&type=script&lang=js&"
export * from "./TestReportInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc99fb10",
  null
  
)

export default component.exports